import { useMutation } from '@apollo/client/react';

import { AppLinkProductsDocument } from 'src/graphql/actions/apps/appLinkProducts.mutation';
import { ClientError } from 'src/utils/errors';

import type { IAppLinkProductsInput } from 'src/graphql/schema';

export const useLinkProducts = () => {
  const [linkProducts] = useMutation(AppLinkProductsDocument);

  return async (input: IAppLinkProductsInput) => {
    const { data } = await linkProducts({ variables: { input } });

    if (!data?.appLinkProducts?.success) throw new ClientError(data?.appLinkProducts?.errors?.[0]);
  };
};
